import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { ConfigJson } from "./config-json.ts";

export let cwr: AwsRum | undefined;

export default function initCwr(c: ConfigJson): AwsRum | undefined {
  if (
    !!c.CWR_ENDPOINT &&
    !!c.CWR_APPLICATION_ID &&
    !!c.CWR_APPLICATION_REGION &&
    !!c.CWR_IDENTITY_POOL_ID
  ) {
    try {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        identityPoolId: c.CWR_IDENTITY_POOL_ID,
        endpoint: c.CWR_ENDPOINT,
        telemetries: ["performance", "errors", "http"],
        allowCookies: true,
        enableXRay: true,
      };

      const APPLICATION_ID: string = c.CWR_APPLICATION_ID;
      const APPLICATION_VERSION: string = import.meta.env["VITE_APP_VERSION"];
      const APPLICATION_REGION: string = c.CWR_APPLICATION_REGION;

      cwr = new AwsRum(
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        config,
      );
      return cwr;
    } catch (error) {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }
}
